import { render, staticRenderFns } from "./amendmentIndex.vue?vue&type=template&id=d471b38c&scoped=true&"
import script from "./amendmentIndex.vue?vue&type=script&lang=js&"
export * from "./amendmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./amendmentIndex.vue?vue&type=style&index=0&id=d471b38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d471b38c",
  null
  
)

export default component.exports